import { useMercadoPagoConfigured } from "~/api/queries/useMercadoPagoConfigured";

type PaymentMethod = "mercadopago";

type CartCurrencyResult = {
  availableMethods: PaymentMethod[];
  defaultMethod: PaymentMethod;
  showToggle: boolean;
  currency: string;
};

export function useCartCurrency(): CartCurrencyResult {
  const { data: mpConfig } = useMercadoPagoConfigured();

  const mpEnabled = mpConfig?.enabled ?? false;

  const availableMethods: PaymentMethod[] = [];
  if (mpEnabled) availableMethods.push("mercadopago");

  const showToggle = false;

  const defaultMethod: PaymentMethod = "mercadopago";

  const currency = "ARS";

  return { availableMethods, defaultMethod, showToggle, currency };
}
